<template>
  <div class="row">
    <div class="left">{{ title }}</div>
    <div v-if="value" class="right">{{ money ? '¥' : '' }}{{ value }}</div>
    <div v-else class="right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "value", "money"],
}
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
  padding: 0 0 2px 0;
  font-size: 0.9rem;
  .left {
    opacity: 0.6;
    min-width: 60px;
  }
  .right {
    text-align: right;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .right,
  code {
    -o-user-select: text;
    -moz-user-select: text;
    -webkit-user-select: text;
    user-select: text;
  }
  .copy {
    &:active {
      i {
        opacity: 0.6;
      }
    }
    i {
      margin-left: 5px;
      transition: all 0.1s;
      &:active {
        opacity: 0.6;
      }
    }
  }
}
</style>